//#region src/cookie.ts
var cookie_exports = /* @__PURE__ */ require("./_virtual/_rolldown/runtime.cjs").__exportAll({ preview: () => preview });
/** The well-known name of the cookie used to store a Prismic preview session's ref. */
const preview = "io.prismic.preview";
//#endregion
Object.defineProperty(exports, "cookie_exports", {
	enumerable: true,
	get: function() {
		return cookie_exports;
	}
});
exports.preview = preview;

//# sourceMappingURL=cookie.cjs.map